import {Component, EventEmitter, Input, Output, OnInit} from '@angular/core';
import {CategoryModel} from '../../models/category.model';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-category-selector',
  templateUrl: 'category-selection.container.component.html',
  styleUrls: ['category-selection.container.component.css']
})
export class CategorySelectionContainerComponent implements OnInit {
  model: CategoryModel[];
  @Input() hierarchyEvent: Subject<CategoryModel[]>;
  @Output() categorySelected: EventEmitter<string> = new EventEmitter<string>();
  cascadeSelected:Subject<string> = new Subject<string>();

  ngOnInit() {
    this.hierarchyEvent.subscribe((hierarchy: CategoryModel[]) => {
      this.model = hierarchy;
      for (let item of this.model) {
        this.cascadeSelected.next(item.id);
      }
    });
  }

  selected(catName: string) {
    this.categorySelected.next(catName);
    this.cascadeSelected.next(catName);
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/components/category-selection/category-selection.container.component.ts